
import { Component, Prop, Watch, Vue } from 'nuxt-property-decorator';
import type { InputFilePartialValue } from '../../types';
import type { FormFieldDto } from '../../services';
import { UploadFileType, FormFieldType } from '../../services';
import InputFile from '../design-system/input/input-file/InputFile.vue';
import InputText from '../design-system/input/input-text/InputText.vue';
import InputTextArea from '../design-system/input/input-text/InputTextArea.vue';
import Modal from '../modals/Modal.vue';

@Component({
  components: {
    InputText,
    InputTextArea,
    Modal,
    InputFile,
  },
})
export default class FormInputFile extends Vue {
  @Prop({ required: true }) readonly field!: FormFieldDto;
  @Prop({ type: String, default: null }) readonly value!: string | null;
  @Prop(Boolean) readonly disabled!: boolean;

  UploadFileType = UploadFileType;
  inputFileValue: InputFilePartialValue | null = null;

  get isVideoField() {
    return this.field.fieldType === FormFieldType.Video;
  }

  get isPdfField() {
    return this.field.fieldType === FormFieldType.Poster || this.field.allowedFileTypes === 'pdf';
  }

  get isImageField() {
    return this.field.fieldType === FormFieldType.Poster || this.field.allowedFileTypes === 'image';
  }

  get additionalAcceptedFileTypes() {
    const fileExtensionMap: [string[], boolean][] = [
      [['.ppt', '.pptx'], this.field.fieldType === FormFieldType.Slides],
      [['.doc', '.docx'], this.field.allowedFileTypes === 'doc'],
    ];

    return fileExtensionMap.flatMap(([extensions, isAccepted]) => (isAccepted ? extensions : []));
  }

  get maxSizeMb() {
    return this.field.fieldType === FormFieldType.Video ? 1000 : 100;
  }

  @Watch('inputFileValue')
  onInputFileValueChange() {
    if (this.inputFileValue?.resourceId === this.value) return;
    this.$emit('input', this.inputFileValue?.resourceId || null);
  }

  created() {
    this.inputFileValue = this.value ? { resourceId: this.value } : null;
  }
}
